class AccountController {
  /* @ngInject */
  constructor(docService, endPoints) {
    const that = this;

    that.showDoc = () => {
      const url =`${endPoints.baseUrl}/api/usr/v2/documents/terms/8`;
      docService.showDoc(url, true);
    };

  }
}

export default AccountController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/account/account.controller.js
 **/